'use client';

import React from 'react';
import { ChatProvider } from '../../contexts/chat-context';

export function AppContent({ children }: { children: React.ReactNode }) {
  return (
    <ChatProvider>
      {children}
    </ChatProvider>
  );
}
